<template>
  <div>
    <AulaTemplate titulo="Pit Stop do Saber" numero="1" titleSize="6">
      <v-row dense class="mt-5 justify-space-between">
        <v-col cols="12" md="5">
          <v-img
            :src="
              require('../../../../assets/modulo_01/atividades/atividade_01/atividade.png')
            "
            alt="Cenário do acidente"
            width="596px"
          ></v-img>
        </v-col>

        <v-col cols="12" md="6">
          <h3>Qual regra deve ser seguida em um cruzamento sem sinalização?</h3>

          <v-row dense class="mt-5">
            <v-col cols="12">
              <v-radio-group v-model="selectedOption" column>
                <v-radio value="a" color="white">
                  <template v-slot:label>
                    <span style="color: white; margin-left: 8px"
                      >a) O veículo que vier pela esquerda tem a
                      preferência</span
                    >
                  </template>
                </v-radio>

                <v-radio value="b" color="white">
                  <template v-slot:label>
                    <span style="color: white; margin-left: 8px"
                      >b) A preferência é sempre do veículo maior</span
                    >
                  </template>
                </v-radio>

                <v-radio value="c" color="white">
                  <template v-slot:label>
                    <span style="color: white; margin-left: 8px"
                      >c) O veículo que vier pela direita do condutor tem a
                      preferência</span
                    >
                  </template>
                </v-radio>

                <v-radio value="d" color="white">
                  <template v-slot:label>
                    <span style="color: white; margin-left: 8px"
                      >d) A preferência é do veículo mais rápido</span
                    >
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-btn color="primary" :disabled="!selectedOption" @click="checkAnswer">Confirmar</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- Caso de Estudo e Dica -->
      <v-row class="mt-5">
        <v-col cols="12" md="7">
          <v-card class="pa-6 rounded-lg" height="100%">
            <h4 class="text-uppercase mb-3 font-weight-bold primary--text">
              Estudo de caso
            </h4>
            <p>
              Ana está dirigindo por uma rua tranquila e chega a um cruzamento
              sem sinalização. No mesmo instante, um outro motorista, Paulo,
              aproxima-se pela direita dela. Ana, conhecedora das regras de
              trânsito, sabe que, em cruzamentos sem semáforos ou placas de
              sinalização, a preferência é do veículo que se aproxima pela
              direita. Assim, ela reduz a velocidade e dá passagem a Paulo,
              evitando uma possível colisão e demonstrando respeito à regra de
              preferência à direita.
            </p>
          </v-card>
        </v-col>

        <v-col cols="12" md="5">
          <v-card class="pa-6 text-center rounded-lg cursor-pointer" height="100%" @click="showTip = !showTip">
            <div class="d-flex align-center justify-center" style="height: 100%;">
              <div v-if="!showTip">
                <v-icon size="66" color="primary" class="mb-2">mdi-lightbulb-outline</v-icon>
                <h2 class="primary--text">DICA</h2>
              </div>

              <div v-else>
                <v-icon size="46" color="primary" class="mb-2">mdi-lightbulb-on</v-icon>
                <h4 class="primary--text">DICA</h4>
                <p >Em cruzamentos sem sinalização clara, sempre reduza a velocidade e verifique ambos os lados, mesmo que a preferência seja sua. Isso não só garante a segurança, mas ajuda a evitar possíveis colisões com motoristas desatentos.</p>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </AulaTemplate>

    <v-dialog v-if="showDialog" v-model="showDialog" max-width="500">
      <v-card class="pa-6 rounded-lg">
        <v-card-text class="text-center d-flex flex-column" style="gap: 40px">
          <div v-if="correctAnswer">
            <v-row justify="center" dense>
              <v-col cols="4">
                <Lottie
                  :happy="true"
                  :sad="false"
                  data-aos="fade-up"
                  data-aos-easing="ease"
                  data-aos-duration="1000"
                  data-aos-once="true"
                />
              </v-col>
              <v-col cols="12">
                <h3 class="mb-2 success--text text-h5 font-weight-bold">
                  Parabens!
                </h3>
                <p>Resposta correta. Continue assim!</p>
              </v-col>
            </v-row>
          </div>

          <div v-else>
            <v-row justify="center" dense>
              <v-col cols="4">
                <Lottie
                  :sad="true"
                  :happy="false"
                  data-aos="fade-up"
                  data-aos-easing="ease"
                  data-aos-duration="1000"
                  data-aos-once="true"
                />
              </v-col>

              <v-col cols="12">
                <h3 class="mb-2 error--text text-h5 font-weight-bold">
                  Resposta incorreta!
                </h3>
                <p>Não desanime. Você consegue!</p>
              </v-col>
            </v-row>
          </div>

          <v-row dense>
            <v-col cols="12">
              <NavButton
                v-if="correctAnswer"
                name="Voltar para aula"
                color="primary"
                block
                @button-click="back"
              ></NavButton>

              <NavButton
                v-else
                name="Tentar novamente"
                color="primary"
                block
                @button-click="showDialog = false"
              ></NavButton>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AulaTemplate from "@/components/AulaTemplate.vue";
import Lottie from "@/components/Lottie.vue";
import NavButton from "@/components/NavButton.vue";

export default {
  components: {
    AulaTemplate,
    Lottie,
    NavButton,
  },
  data() {
    return {
      selectedOption: null, // Opção selecionada
      showDialog: false,
      correctAnswer: false,
      showTip: false
    };
  },
  methods: {
    checkAnswer() {
      this.showDialog = true;
      if (this.selectedOption === "c") {
        this.correctAnswer = true;
      } else {
        this.correctAnswer = false;
      }
    },

    back() {
      this.showDialog = false;
      this.$router.push({ path: "/topico-1", query: { goTo: 'goToPitStop_1' } });
    },
  },

  created() {
    this.$store.commit('ADICIONAR_SCORE', 'atividade_1_topico_01');
  },
};
</script>

<style scoped>
h3 {
  color: white;
}
</style>
